
export default function Experiences() {
  const experiences = [
    {
      title: 'Tour por la Costa',
      image: 'https://public.readdy.ai/ai/img_res/5b369f3aac42f00c28925a9c50520bbf.jpg',
      duration: '3 horas',
      description: 'Recorre la hermosa costa de Veracruz y descubre playas escondidas, arrecifes de coral y la belleza natural del Golfo de México. Incluye paradas para nadar y snorkel.',
      highlights: ['Playas vírgenes', 'Snorkel incluido', 'Guía turístico', 'Bebidas refrescantes']
    },
    {
      title: 'Pesca Deportiva',
      image: 'https://readdy.ai/api/search-image?query=sport%20fishing%20from%20boat%20on%20open%20ocean%2C%20fishing%20rods%20and%20equipment%20ready%2C%20deep%20blue%20waters%2C%20professional%20fishing%20photography%2C%20action%20shot%2C%20clear%20sky%20background&width=800&height=600&seq=exp-002&orientation=landscape',
      duration: '4-6 horas',
      description: 'Vive la emoción de la pesca deportiva en las mejores zonas del Golfo. Equipo profesional incluido y guía experto que te llevará a los mejores puntos de pesca.',
      highlights: ['Equipo profesional', 'Carnada incluida', 'Guía experto', 'Limpieza del pescado']
    },
    {
      title: 'Atardecer Romántico',
      image: 'https://readdy.ai/api/search-image?query=romantic%20sunset%20cruise%20on%20luxury%20yacht%2C%20golden%20hour%20over%20calm%20ocean%2C%20couple%20enjoying%20champagne%2C%20beautiful%20orange%20and%20pink%20sky%2C%20professional%20romantic%20photography&width=800&height=600&seq=exp-003&orientation=landscape',
      duration: '2 horas',
      description: 'Disfruta de un atardecer mágico en el mar con tu pareja. Incluye champagne, música ambiental y un recorrido por las mejores vistas del puerto al caer el sol.',
      highlights: ['Champagne incluido', 'Música romántica', 'Fotografías de cortesía', 'Aperitivos gourmet']
    },
    {
      title: 'Fiesta en el Mar',
      image: 'https://readdy.ai/api/search-image?query=party%20celebration%20on%20yacht%20deck%2C%20people%20dancing%20and%20having%20fun%2C%20festive%20atmosphere%2C%20DJ%20equipment%2C%20colorful%20lights%2C%20professional%20event%20photography%2C%20ocean%20setting&width=800&height=600&seq=exp-004&orientation=landscape',
      duration: 'Personalizado',
      description: 'Celebra tu evento especial en el mar. Cumpleaños, despedidas, aniversarios o reuniones corporativas. Personalizamos cada detalle según tus necesidades.',
      highlights: ['DJ y sonido', 'Catering opcional', 'Decoración incluida', 'Barra libre disponible']
    }
  ];

  return (
    <section id="experiences" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Experiencias Únicas
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Paquetes especiales diseñados para crear momentos inolvidables en el mar
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {experiences.map((exp, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative w-full h-72 overflow-hidden">
                <img
                  src={exp.image}
                  alt={exp.title}
                  className="w-full h-full object-cover object-top"
                  onError={(e) => {
                    e.currentTarget.src = 'https://via.placeholder.com/800x600?text=Imagen+no+disponible';
                  }}
                />
                <div className="absolute top-4 left-4 bg-teal-500 text-white px-4 py-2 rounded-full font-semibold flex items-center">
                  <i className="ri-time-line mr-2"></i>
                  {exp.duration}
                </div>
              </div>

              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {exp.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {exp.description}
                </p>

                <div className="grid grid-cols-2 gap-3 mb-6">
                  {exp.highlights.map((highlight, idx) => (
                    <div key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-star-fill text-teal-500 mr-2"></i>
                      <span>{highlight}</span>
                    </div>
                  ))}
                </div>

                <button className="w-full py-3 bg-teal-500 hover:bg-teal-600 text-white font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer">
                  Más Información
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
